import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Main from 'layouts/Main';
import React from 'react';
import { Hero, HowToRequest, WhatWeDelete } from './components';

const DataDeletion = () => {
  return (
    <Main>
      <Container>
        <Box>
          <Hero />
        </Box>
        <Box>
          <WhatWeDelete />
        </Box>
        <Box>
          <HowToRequest />
        </Box>
      </Container>
    </Main>
  );
};

export default DataDeletion;
